<template>
  <div class="btn-group btn-group-sm">
    
    <button v-if="can_access('transaction','modify')" class="btn btn-edit" title="Edit Transaction" @click="showModal('edit')"><i class="fa fa-edit"></i></button>

    <b-modal ref="edit-transaction-out" title="Add Transaction" size="xl" hide-footer>
      <p class="my-4"><AddTransactionForm :rows="rowData" :forceRerender="transactionFormReRender"/></p>
    </b-modal>
  </div>
</template>
<script>
import $ from 'jquery';
import AddTransactionForm from '@/components/Accounts/AddTransactionForm';
import common from '@/assets/js/common.js';
export default {
  props: ['row', 'nested'],
  mixins: [common],
  data(){
    return {
      rowData:{}
    }
  },
  components: {  AddTransactionForm },
  mounted () {
    //$(this.$el).find('button[title]').tooltip()
  },
  computed: {
  },
  methods: {
    transactionFormReRender(response) {
      if(response.code==0){
        this.$refs['edit-transaction-out'].hide()
        this.$toasted.success("Successfully Added",{duration:1000});
      }
    },
    toggleNestedComp (comp) {
      const { nested } = this
      if (nested.comp === comp) return nested.$toggle()
      nested.$toggle(comp, true)
    },
    showModal(action) {
        if(action=='edit'){
            this.rowData = this.duplicate(this.row);
            this.rowData.action = 'edit'
        }
        this.$refs['edit-transaction-out'].show()
    },
  }
}
</script>
<style>
.-nested-comp-open-btn {
  color: #fff !important;
  background-color: #337ab7 !important;
}
dd, dt {
    line-height: 1.42857143;
}
</style>
